export const clientId = '337401337490-fpq853p48bc66psrtf9b5higlu2uf1pl.apps.googleusercontent.com';
export const scope = 'email profile openid';
export const getUserApi = 'https://www.googleapis.com/oauth2/v3/userinfo';
export const gaID = 'G-2CD69F6BQB';

export const domain = 'https://blockfin.com';
export const s2Domain = 'https://s2.blockfin.com';
export const seoImagePath = '/blockfin/seo/en.jpeg';
